import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import sanitizeHtml from 'sanitize-html'; // ------------------------------

var state = {}; // ------------------------------
// 共通methodはこのgetters記載

var getters = {
  h: function h() {
    return function (str) {
      // v-htmlの脆弱性対策
      try {
        return sanitizeHtml(str);
      } catch (error) {
        return '';
      }
    };
  },
  nl2br: function nl2br() {
    return function (str) {
      // 改行をBRに変換
      try {
        str = str.replace(/\r\n/g, '<br />');
        str = str.replace(/(\n|\r)/g, '<br />');
        return str;
      } catch (error) {
        return str;
      }
    };
  }
}; // ------------------------------

var mutations = {}; // ------------------------------

var actions = {}; // ------------------------------

export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
};